import {
    DropdownButtonType,
    List,
    ListItem,
    ListProps,
    RadioButtonWithLabelGroupWidget,
    SingleSelectDropdown,
    TabStyles} from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { IOAuthCredential } from '~src/connectivity/serverApi/types/OAuth/IOAuthCredential';
import { cssClass } from '~src/style';

import _ = require('underscore');

const option: string = cssClass('edit-oauth-connection', 'embedded-option', {
    marginBottom: TabStyles.Sizing.BaseUnit * 2,
});

const optionText: string = cssClass('edit-oauth-connection', 'option-text', {
    marginBottom: TabStyles.Sizing.BaseUnit,
});

const optionSubText: string = cssClass('edit-oauth-connection', 'option-subtext', {
    color: TabStyles.Typography.Color.Secondary
});

const authenticationLabel: string = cssClass('edit-oauth-connection', 'authentication-label', {
    marginTop: TabStyles.Sizing.BaseUnit * 3,
    marginBottom: TabStyles.Sizing.BaseUnit * 2,
    fontWeight: 'bold'
});

export type EditOAuthConnectionDialogEmbeddedToggleProps = Readonly<{
    credentialNoValueOptionText: string;
    currentConnectionTypeDisplayName: string;
    addNewOAuthCredentialOptionValue: string;
    credentialId: string;
    credentials: IOAuthCredential[];
    credentialOption: string;
    handleToggleChange: (isPasswordEmbedded: boolean) => void;
    handleCredentialIdChange: (newCredentialId: string) => void;
}>;

export function EditOAuthConnectionDialogEmbeddedToggle(props: EditOAuthConnectionDialogEmbeddedToggleProps) {
    function getNameForIOAuthCredentialId(value: string, items: ListItem[]): React.ReactNode {
        if (!items.find(item => item.value === value)) {
            return props.credentialNoValueOptionText || Messages.selectOAuthCredential();
        } else {
            return items.find(item => item.value === value).content;
        }
    }

    function getIOAuthCredentialIdsList(ioauthCredentials: IOAuthCredential[]): ListItem[] {
        const items: ListItem[] = [];
        if (ioauthCredentials) {
            ioauthCredentials.map((ioauthCredential) => {
                items.push({ value: ioauthCredential.id, content: ioauthCredential.role ? ioauthCredential.username + (ioauthCredential.role && ' (' + ioauthCredential.role + ')') : ioauthCredential.username });
            });
        }
        return items;
    }

    const renderOAuthCredentialOptionSelector = (ariaLabel: string): React.ReactNode => {
        if (props.credentialOption !== 'oauth' &&  props.credentialOption !== 'keypair') {
            return null;
        }

        let items: ListItem[] = [];
        if (props.credentials) {
            items = getIOAuthCredentialIdsList(props.credentials);
        }
        if (props.addNewOAuthCredentialOptionValue) {
            items.push({ value: props.addNewOAuthCredentialOptionValue,
                content: Messages.addOAuthCredential({ CONNECTION_TYPE_NAME: props.currentConnectionTypeDisplayName +
                    (props.credentialOption === 'keypair' ? ' '.concat(Messages.addNewCredential_KeyPairAuth()): '') }) });
        }
        const listProps: ListProps = { items };

        return (
            <SingleSelectDropdown
                aria-label={ariaLabel}
                label=''
                list={<List {...listProps} />}
                onChange={props.handleCredentialIdChange}
                type={DropdownButtonType.Outline}
                value={props.credentialId}
                style={{ marginBottom: TabStyles.Sizing.BaseUnit }}
            >
                {getNameForIOAuthCredentialId(props.credentialId, items)}
            </SingleSelectDropdown>
        );
    };

    return (
        <RadioButtonWithLabelGroupWidget
            className={authenticationLabel}
            label={<div className={authenticationLabel}>{Messages.authentication()}</div>}
            buttonList={[
                {
                    label: <div className={optionText}>{Messages.editDataConnections_generic_embedCredential()}</div>,
                    detail:
                        <div className={option}>
                            {renderOAuthCredentialOptionSelector(Messages.editDataConnections_generic_embedCredential())}
                            <label className={optionSubText}>{Messages.editDataConnections_generic_describeEmbedCredential()}</label>
                        </div>,
                    testId: 'embedded',
                    value: true,
                    disabled: (!props.credentials || props.credentials.length === 0) && !props.addNewOAuthCredentialOptionValue,
                },
                {
                    label: <div className={optionText}>{Messages.editDataConnections_generic_noCredential()}</div>,
                    detail:
                        <div className={option}>
                            <label className={optionSubText}>{Messages.editDataConnections_generic_describeNoCredential()}</label>
                        </div>,
                    testId: 'no-auth',
                    value: false,
                },
            ]}
            checkedIndex={props.credentialOption === 'oauth' || props.credentialOption === 'keypair' ? 0 : 1}
            handleChange={(value) => props.handleToggleChange(value)}
        />
    );
}
